export default __webpack_public_path__ + "static/diplomats_Campaigner_ENFP_career_path-ba8f1786ef82142ca653c6d2ead6c073.svg";